import { useState, useEffect } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { FileCode, Plus, Trash2, Save } from "lucide-react";

const KOD_LIST = [
  { kod: "7168", ad: "Asıl Alacak", kod_aciklama: "ASIL ALACAK", kod_turu: "1" },
  { kod: "7183", ad: "Geçmiş Gün Faizi", kod_aciklama: "ASIL ALACAK'ın DEĞİŞEN ORANLARDA İŞLEMİŞ Yasal FAİZİ", kod_turu: "2" },
  { kod: "8707", ad: "vekalet ücreti", kod_aciklama: "VEKALET ÜCRETİ", kod_turu: "0" },
];

const emptyKalem = () => ({ ad: "Asıl Alacak", kod: "7168", kod_aciklama: "ASIL ALACAK", tutar: "", kod_turu: "1", faiz_oran: "48", faiz_baslangic: "", faiz_tipi: "" });

const inp = "px-3 py-2 border border-[#E7DECC] rounded-sm text-sm focus:outline-none focus:border-[#B8933F] bg-white";
const lbl = "text-xs text-[#8C8377] block mb-1";

export default function TakipXmlSection({ rec, canEdit, indirBlob, busy, onSaved }) {
  const [f, setF] = useState({
    adres: "", il: "", ilce: "", ilce_kodu: "", cinsiyet: "E",
    tanzim_tarihi: "", tanzim_yeri: "BURSA", odeme_yeri: "BURSA", vade_tarihi: "", belge_tutari: "", ek_talep: "",
  });
  const [kalemler, setKalemler] = useState([emptyKalem()]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!rec) return;
    const ts = rec.takip_senet || {};
    setF({
      adres: rec.adres || "",
      il: rec.il || "",
      ilce: rec.ilce || "",
      ilce_kodu: rec.ilce_kodu || "",
      cinsiyet: rec.cinsiyet || "E",
      tanzim_tarihi: (ts.tanzim_tarihi || "").slice(0, 10),
      tanzim_yeri: ts.tanzim_yeri || "BURSA",
      odeme_yeri: ts.odeme_yeri || "BURSA",
      vade_tarihi: ((ts.vade_tarihi || rec.senet?.vade_tarihi || rec.vade_tarihi) || "").slice(0, 10),
      belge_tutari: ts.belge_tutari ?? (rec.senet?.tutar || ""),
      ek_talep: rec.takip_ek_talep || "",
    });
    if (rec.alacak_kalemleri && rec.alacak_kalemleri.length) {
      setKalemler(rec.alacak_kalemleri.map((k) => ({
        ...k, tutar: k.tutar ?? "", faiz_oran: k.faiz_oran ?? "", faiz_baslangic: (k.faiz_baslangic || "").slice(0, 10),
      })));
    } else {
      setKalemler([
        { ...emptyKalem(), tutar: rec.asil_alacak || "", faiz_baslangic: ((rec.senet?.vade_tarihi || rec.vade_tarihi) || "").slice(0, 10) },
      ]);
    }
  }, [rec]);

  const setKalem = (i, patch) => setKalemler((ks) => ks.map((k, idx) => (idx === i ? { ...k, ...patch } : k)));  const onKodChange = (i, kod) => {
    const meta = KOD_LIST.find((x) => x.kod === kod);
    if (meta) setKalem(i, { kod, ad: meta.ad, kod_aciklama: meta.kod_aciklama, kod_turu: meta.kod_turu });
    else setKalem(i, { kod });
  };
  const addKalem = () => setKalemler((ks) => [...ks, emptyKalem()]);
  const delKalem = (i) => setKalemler((ks) => ks.filter((_, idx) => idx !== i));

  const payload = () => ({
    adres: f.adres, il: f.il, ilce: f.ilce, ilce_kodu: f.ilce_kodu, cinsiyet: f.cinsiyet,
    tanzim_tarihi: f.tanzim_tarihi || null, tanzim_yeri: f.tanzim_yeri, odeme_yeri: f.odeme_yeri,
    vade_tarihi: f.vade_tarihi || null, belge_tutari: f.belge_tutari === "" ? null : Number(f.belge_tutari),
    ek_talep: f.ek_talep,
    alacak_kalemleri: kalemler.map((k) => ({
      ad: k.ad, kod: k.kod, kod_aciklama: k.kod_aciklama, kod_turu: k.kod_turu,      tutar: Number(k.tutar || 0),
      faiz_oran: k.faiz_oran === "" || k.faiz_oran == null ? null : Number(k.faiz_oran),
      faiz_baslangic: k.faiz_baslangic || null,
      faiz_tipi: k.faiz_tipi || null,
    })),
  });

  const save = async () => {
    setSaving(true);
    try {
      await api.put(`/records/${rec.id}/takip-bilgi`, payload());
      toast.success("Takip bilgileri kaydedildi");
      onSaved && onSaved();
    } catch (e) { toast.error(e.response?.data?.detail || "Kaydedilemedi"); }
    finally { setSaving(false); }
  };

  const saveAndDownload = async () => {
    await save();
    indirBlob("takip_xml", `/records/${rec.id}/takip-xml`, { ornek: "10" });
  };

  if (!canEdit) return null;

  const faizPreview = (() => {
    const a = kalemler.find((k) => String(k.kod_turu) === "1" && k.faiz_oran && k.tutar);
    if (!a || !f.vade_tarihi) return null;
    const b = new Date(f.vade_tarihi);
    if (isNaN(b.getTime())) return null;
    b.setDate(b.getDate() + 1);
    const gun = Math.max(0, Math.floor((new Date() - b) / 86400000));
    const tutar = Math.round(Number(a.tutar) * (Number(a.faiz_oran) / 100) * gun / 365 * 100) / 100;
    const eff = a.faiz_tipi || (Math.round(Number(a.faiz_oran)) === 48 ? "FAIZT00003" : "FAIZT00002");
    const tip = eff === "FAIZT00003" ? "Diğer / Basit Faiz" : "Adi Kanuni (Yasal) Faiz";
    return { gun, tutar, oran: a.faiz_oran, baslangic: b.toISOString().slice(0, 10), tip };
  })();

  return (
    <div className="bg-white border border-[#E7DECC] rounded-sm p-5 mb-6" data-testid="takip-xml-section">
      <div className="flex items-center gap-2 mb-1">
        <FileCode className="w-4 h-4 text-[#B8933F]" />
        <div className="kicker">İCRA TAKİBİ AÇ — UYAP XML (Örnek 10 · Kambiyo)</div>
      </div>
      <p className="text-xs text-[#8C8377] mb-4">Aşağıdaki bilgilerle UYAP'a doğrudan yüklenebilir takip açma dosyası (.xml) üretilir. Alacaklı (Gençer) ve vekil (Av. Hatice Ata Taş) bilgileri sabittir. İl kodu plakadan otomatik gelir; ilçe kodunu gerekirse elle girin.</p>

      <div className="text-xs font-semibold text-[#26231E] mb-2 uppercase tracking-wide">Borçlu Bilgileri</div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-3 mb-4">
        <div className="md:col-span-4">
          <label className={lbl}>Adres</label>
          <input value={f.adres} onChange={(e) => setF({ ...f, adres: e.target.value })} data-testid="takip-adres" placeholder="Tam adres (… OSMANGAZİ/BURSA)" className={inp + " w-full"} />
        </div>
        <div><label className={lbl}>İl</label><input value={f.il} onChange={(e) => setF({ ...f, il: e.target.value })} data-testid="takip-il" placeholder="BURSA" className={inp + " w-full"} /></div>
        <div><label className={lbl}>İlçe</label><input value={f.ilce} onChange={(e) => setF({ ...f, ilce: e.target.value })} data-testid="takip-ilce" placeholder="OSMANGAZİ" className={inp + " w-full"} /></div>
        <div><label className={lbl}>İlçe Kodu (ops.)</label><input value={f.ilce_kodu} onChange={(e) => setF({ ...f, ilce_kodu: e.target.value })} data-testid="takip-ilce-kodu" className={inp + " w-full"} /></div>
        <div>
          <label className={lbl}>Cinsiyet</label>
          <select value={f.cinsiyet} onChange={(e) => setF({ ...f, cinsiyet: e.target.value })} data-testid="takip-cinsiyet" className={inp + " w-full"}>
            <option value="E">Erkek (E)</option>
            <option value="K">Kadın (K)</option>
          </select>
        </div>
      </div>

      <div className="text-xs font-semibold text-[#26231E] mb-2 uppercase tracking-wide">Senet / Bono Bilgileri</div>
      <div className="grid grid-cols-1 md:grid-cols-5 gap-3 mb-4">
        <div><label className={lbl}>Tanzim Tarihi</label><input type="date" value={f.tanzim_tarihi} onChange={(e) => setF({ ...f, tanzim_tarihi: e.target.value })} data-testid="takip-tanzim-tarihi" className={inp + " w-full"} /></div>
        <div><label className={lbl}>Vade Tarihi</label><input type="date" value={f.vade_tarihi} onChange={(e) => setF({ ...f, vade_tarihi: e.target.value })} data-testid="takip-vade" className={inp + " w-full"} /></div>
        <div><label className={lbl}>Belge (Senet) Tutarı</label><input type="number" value={f.belge_tutari} onChange={(e) => setF({ ...f, belge_tutari: e.target.value })} data-testid="takip-belge-tutar" className={inp + " w-full"} /></div>
        <div><label className={lbl}>Tanzim Yeri</label><input value={f.tanzim_yeri} onChange={(e) => setF({ ...f, tanzim_yeri: e.target.value })} data-testid="takip-tanzim-yeri" className={inp + " w-full"} /></div>
        <div><label className={lbl}>Ödeme Yeri</label><input value={f.odeme_yeri} onChange={(e) => setF({ ...f, odeme_yeri: e.target.value })} data-testid="takip-odeme-yeri" className={inp + " w-full"} /></div>
      </div>

      <div className="flex items-center justify-between mb-2">
        <div className="text-xs font-semibold text-[#26231E] uppercase tracking-wide">Alacak Kalemleri</div>
        <button onClick={addKalem} data-testid="takip-kalem-ekle" className="flex items-center gap-1 px-3 py-1.5 bg-[#EFE7D6] hover:bg-[#E7DECC] text-[#26231E] rounded-sm text-xs font-medium"><Plus className="w-3.5 h-3.5" /> Kalem Ekle</button>
      </div>
      <div className="overflow-x-auto mb-4">
        <table className="w-full text-sm border border-[#E7DECC]">
          <thead className="bg-[#F3ECDD]">
            <tr>
              {["Kalem", "Kod", "Tutar (TL)", "Faiz Oranı %", "Faiz Türü", ""].map((h) => <th key={h} className="px-2 py-2 text-left kicker">{h}</th>)}
            </tr>
          </thead>
          <tbody>
            {kalemler.map((k, i) => (
              <tr key={i} className="border-t border-[#E7DECC]" data-testid={`takip-kalem-row-${i}`}>
                <td className="px-2 py-1.5">
                  <select value={KOD_LIST.find((x) => x.kod === k.kod) ? k.kod : "custom"} onChange={(e) => e.target.value !== "custom" && onKodChange(i, e.target.value)} className={inp + " w-full"} data-testid={`takip-kalem-kod-sel-${i}`}>
                    {KOD_LIST.map((x) => <option key={x.kod} value={x.kod}>{x.ad}</option>)}
                    <option value="custom">Diğer…</option>
                  </select>
                  <input value={k.ad} onChange={(e) => setKalem(i, { ad: e.target.value })} className={inp + " w-full mt-1"} placeholder="Kalem adı" />
                </td>
                <td className="px-2 py-1.5"><input value={k.kod} onChange={(e) => setKalem(i, { kod: e.target.value })} className={inp + " w-20"} data-testid={`takip-kalem-kod-${i}`} /></td>
                <td className="px-2 py-1.5"><input type="number" value={k.tutar} onChange={(e) => setKalem(i, { tutar: e.target.value })} className={inp + " w-32"} data-testid={`takip-kalem-tutar-${i}`} /></td>
                <td className="px-2 py-1.5"><input type="number" value={k.faiz_oran} onChange={(e) => setKalem(i, { faiz_oran: e.target.value })} className={inp + " w-24"} placeholder="48" data-testid={`takip-kalem-faiz-${i}`} /></td>
                <td className="px-2 py-1.5">
                  <select value={k.faiz_tipi || ""} onChange={(e) => setKalem(i, { faiz_tipi: e.target.value })} className={inp + " w-44"} data-testid={`takip-kalem-faiztipi-${i}`}>
                    <option value="">Otomatik (48→Diğer)</option>
                    <option value="FAIZT00002">Adi Kanuni (Yasal)</option>
                    <option value="FAIZT00003">Diğer / Basit</option>
                  </select>
                </td>
                <td className="px-2 py-1.5">{kalemler.length > 1 && <button onClick={() => delKalem(i)} data-testid={`takip-kalem-sil-${i}`} className="text-[#A63A3A] hover:opacity-70"><Trash2 className="w-4 h-4" /></button>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {faizPreview && (
        <div className="mb-4 p-3 rounded-sm border border-[#B8933F]/50 bg-[#FBF6EA]" data-testid="takip-faiz-onizleme">
          <div className="text-xs font-semibold text-[#26231E] uppercase tracking-wide mb-1">Geçmiş Gün Faizi (Otomatik Hesaplanan)</div>
          <div className="text-sm text-[#4A453D]">
            <b>{faizPreview.tip}</b> · Vade+1 (<b>{faizPreview.baslangic}</b>) tarihinden bugüne <b>{faizPreview.gun} gün</b> × %{faizPreview.oran} işlemiş faiz = <b data-testid="takip-faiz-tutar">{faizPreview.tutar.toLocaleString("tr-TR", { minimumFractionDigits: 2 })} TL</b>
          </div>
          <div className="text-xs text-[#8C8377] mt-1">Faiz başlangıcı her zaman <b>vade tarihinden 1 gün sonra</b> alınır. Oran 48 ise "Diğer/Basit Faiz", değilse "Adi Kanuni (Yasal) Faiz" kodlanır. Bu tutar XML'e "Geçmiş Gün Faizi" (kod 7183) olarak otomatik eklenir ve indirme günü tarihine göre yeniden hesaplanır.</div>
        </div>
      )}

      <div className="mb-4">
        <label className={lbl}>Ek Talep Metni (opsiyonel — protokol/bağlantılı dosya notu)</label>
        <textarea value={f.ek_talep} onChange={(e) => setF({ ...f, ek_talep: e.target.value })} data-testid="takip-ek-talep" rows={2} className={inp + " w-full"} />
      </div>

      <div className="flex items-center gap-3">
        <button onClick={save} disabled={saving} data-testid="takip-kaydet" className="flex items-center gap-1.5 px-4 py-2 bg-[#26231E] hover:bg-[#333] text-white rounded-sm text-sm font-medium disabled:opacity-60"><Save className="w-4 h-4" /> Bilgileri Kaydet</button>
        <button onClick={saveAndDownload} disabled={saving || busy === "takip_xml"} data-testid="takip-xml-indir" className="flex items-center gap-1.5 px-4 py-2 bg-[#B8933F] hover:bg-[#9C7A33] text-white rounded-sm text-sm font-medium disabled:opacity-60"><FileCode className="w-4 h-4" /> XML İndir (Örnek 10)</button>
      </div>
    </div>
  );
}
